var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.534,
    height: 16.567,
    viewBox: "0 0 16.534 16.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4a4a4a;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7523",
    "data-name": "Path 7523",
    className: "cls-1",
    d: "M100.273,27.867l-2.958-2.958a7.231,7.231,0,1,0-1.845,1.879l2.958,2.958a.862.862,0,0,0,1.236,0l.626-.626a.9.9,0,0,0-.017-1.253ZM87.6,24.491a5.254,5.254,0,1,1,7.431,0A5.252,5.252,0,0,1,87.6,24.491Z",
    transform: "translate(-84.002 -13.441)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/Icon_Search.a56338de0f08c22178b18aab0077afef.svg";
export { ForwardRef as ReactComponent };